<template>
  <div>
    <!-- 我的资产 -->
    <div class="myassets w">
      <!-- 资产分布 -->
      <div class="assets">
        <div class="assets_con">
          <!-- 我的资产 -->
          <div class="distribution fl">
            <span class="distribution_words">资产分布</span>
            <img src="../../assets/images/echarts.png" alt="" class="noData" v-show="noDataShow">
            <div v-loading="echartsLoading" element-loading-text="加载中..." id="zz" style="width:428px;height:240px;position: absolute;top:0px;"></div>
            <ul class="distribution_detail">
              <li>我的总资产(元)：<span>{{assetsTotal}}</span></li>
              <li>昨日收益(元)：<span :class="[{'rColor':incomeLast > 0},{'gColor':incomeLast < 0}]">{{incomeLast}}</span></li>
              <li>持有收益(元)：<span :class="[{'rColor':incomeHold > 0},{'gColor':incomeHold < 0}]">{{incomeHold}}</span></li>
              <li>累计收益(元)：<span :class="[{'rColor':incomeTotal > 0},{'gColor':incomeTotal < 0}]">{{incomeTotal}}</span></li>
            </ul>
          </div>
          <div class="dottedLine fl"></div>
          <!-- 卡券 -->
          <div class="coupon fr">
            <div class="couponCard btnOne">
              <p class="coupon1" @click="$router.push({name:'coupon'})">卡券</p>
              <p class="coupon2">您有<span class="colorBlue"> {{cardCoupon}} </span>张卡券可以使用</p>
              <el-button type="simple" @click="$router.push({name: 'coupon'})">查看详情</el-button>
            </div>
            <div class="couponCard btnOne" style="margin-top: 10px;position: relative;">
              <p class="coupon1" @click="$router.push({name:'member'})">点财通会员</p>
              <ul class="coupon2">
                <li>可用积分：<span class="colorBlue">{{integral}}</span></li>
                <li>会员截止：<span class="colorBlue">{{memberDate}}</span></li>
                <li>
                  <img v-show="overdueShow" src="../../assets/images/overdue.png" class="overdue" alt="">
                </li>
              </ul>
              <el-button type="simple" @click="renewClick">{{memberFlag? '续费':'开通'}}</el-button>
              <el-button type="simple" @click="$router.push({name:'pointsRecord'})">积分记录</el-button>
              <el-button type="simple" @click="exchangeClick">积分兑换</el-button>
            </div>
          </div>
        </div>
        <!-- 公告 -->
        <div class="assets_foot notice">
          <img class="hornImg" src="../../assets/images/20210303_lb.png" alt="">
          <p class="hornTit">公告：</p>
          <div class="hornWords">
            <span v-show="!hornShow">暂无公告</span>
            <vue-seamless-scroll v-show="hornShow" :data="listData" :class-option="classOption" class="warp">
              <ul class="ul-item">
                <li class="li-item"></li>
              </ul>
            </vue-seamless-scroll>
          </div>
        </div>
      </div>
      <!-- 基金模块 -->
      <ul class="fundModule" id="fundModule">
        <li class="mod active">
          <div class="boxTitle">恒宝宝</div>
          <p class="fundTol">总资产(元)<span>{{hbbTotalAssets}}</span></p>
          <ul class="profitBox">
            <li>七日年化收益率：<span :class="[{'rColor':parseFloat(hbbSyl) > 0},{'gColor':parseFloat(hbbSyl) < 0}]">{{hbbSyl}}</span></li>
            <li>
              昨日收益(元)：
              <span v-if="hbbLastSY > 0" class="rColor">{{'+'+hbbLastSY}}</span>
              <span v-else-if="hbbLastSY < 0" class="gColor">{{'-'+hbbLastSY}}</span>
              <span v-else>{{hbbLastSY}}</span>
            </li>
            <li>
              累计收益(元)：
              <span v-if="hbbAllSY > 0" class="rColor">{{'+'+hbbAllSY}}</span>
              <span v-else-if="hbbAllSY < 0" class="gColor">{{'-'+hbbAllSY}}</span>
              <span v-else>{{hbbAllSY}}</span>
            </li>
          </ul>
          <!-- 操作 -->
          <div class="fundOperation btnTwo">
            <el-button type="primary" @click="$router.push({name: 'recharge',})">充值</el-button>
            <el-button type="primary" @click="$router.push({name: 'fixedInvestment'})">定投</el-button>
            <el-button type="primary" @click="$router.push({name: 'takeCash',})">提现</el-button>
            <el-button type="primary" @click="$router.push({name: 'record',})">记录</el-button>
          </div>
          <!-- 展开详情 -->
          <span class="open" id="open" @click="spread('hbb')">
            <span v-show="!hbbShow"> 展开详情 </span>
            <i :class="hbbShow?'el-icon-arrow-up' : 'el-icon-arrow-down'  "></i>
          </span>
        </li>
        <!-- <li class="mod">
          <div class="boxTitle">基金组合</div>
          <p class="fundTol">
            总资产(元)
            <span>{{combinationTotalAssets}}</span>
          </p>
          <ul class="profitBox">
            <li>
              昨日收益(元)：
              <span v-if="combinationLastSY > 0" class="rColor">{{'+'+combinationLastSY}}</span>
              <span v-else-if="combinationLastSY < 0" class="gColor">{{combinationLastSY}}</span>
              <span v-else>{{combinationLastSY}}</span>
            </li>
            <li>
              持有收益(元)：
              <span v-if="combinationHold > 0" class="rColor">{{'+'+combinationHold}}</span>
              <span v-else-if="combinationHold < 0" class="gColor">{{combinationHold}}</span>
              <span v-else>{{combinationHold}}</span>
            </li>
            <li>
              累计收益(元)：
              <span v-if="combinationAllSY > 0" class="rColor">{{'+'+combinationAllSY}}</span>
              <span v-else-if="combinationAllSY < 0" class="gColor">{{combinationAllSY}}</span>
              <span v-else>{{combinationAllSY}}</span>
            </li>
          </ul>
          <div class="fundOperation btnTwo">
            <el-button type="primary" @click="combinationBuy">买入</el-button>
            <el-button type="primary" @click="combinationRecord">记录</el-button>
            <el-button type="primary" style="width: 70px;" @click="$router.push({name:'combinationAdjustRecord'})">调仓记录</el-button>
          </div>
          <span class="open" @click="zhClick">
            <span v-show="flag2"> 展开详情 </span>
            <i :class="flag2 == true? 'el-icon-arrow-down':'el-icon-arrow-up'"></i>
          </span>
        </li> -->
        <li class="mod">
          <div class="boxTitle">公募基金</div>
          <p class="fundTol">总资产(元)<span>{{publicTotalAssets}}</span></p>
          <ul class="profitBox">
            <li>昨日收益(元)：<span :class="[{'rColor':publiclastSY > 0},{'gColor':publiclastSY < 0}]">{{(publiclastSY>0?'+':'')+publiclastSY}}</span></li>
            <li>持有收益(元)：<span :class="[{'rColor':publicholdSY > 0},{'gColor':publicholdSY < 0}]">{{(publicholdSY>0?'+':'')+publicholdSY}}</span></li>
            <li>累计收益(元)：<span :class="[{'rColor':publicallSY > 0},{'gColor':publicallSY < 0}]">{{(publicallSY>0?'+':'')+publicallSY}}</span></li>
          </ul>
          <!-- 操作 -->
          <div class="fundOperation btnTwo">
            <el-button type="primary" @click="$router.push({name: 'publicPurchaseLists',})">买入</el-button>
            <el-button type="primary" style="width: 70px;" @click="$router.push({name: 'fixedManagement',})">定投管理</el-button>
            <el-button type="primary" @click="$router.push({name: 'publicRecord',})">记录</el-button>
          </div>
          <!-- 展开详情 -->
          <span class="open" @click="spread('gm')"><span v-show="!gmShow"> 展开详情 </span><i :class="!gmShow? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i></span>
        </li>
        <li class="mod">
          <div class="boxTitle">私募基金</div>
          <p class="fundTol">总资产(元)<span>{{privateTotalAssets}}</span></p>
          <ul class="profitBox">
            <li>持有产品数量：<span :class="[{'rColor':privateCount > 0}]">{{privateCount}}</span></li>
            <li>最新净值日期：<span :class="[{'rColor':privateNewDate != '--'}]">{{privateNewDate != '--'? privateNewDate : '暂无数据'}}</span></li>
            <li>持有收益(元)：<span :class="[{'rColor':privateallSY > 0},{'gColor':privateallSY < 0}]">{{(privateallSY>0?'+':'')+privateallSY}}</span></li>
          </ul>
          <!-- 操作 -->
          <div class="fundOperation btnTwo">
            <el-button type="primary" @click="dialogVisable = true">买入</el-button>
            <el-button type="primary" @click="$router.push({name: 'privateRecord',})">记录</el-button>
          </div>
          <!-- 展开详情 -->
          <span class="open" @click="spread('sm')">
            <span v-show="!smShow"> 展开详情 </span>
            <i :class="!smShow? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
          </span>
        </li>
      </ul>
      <!-- 基金模块内容 -->
      <div class="fundModuleCon">
        <Hbb v-show="hbbShow" style="margin-bottom: 0"></Hbb>
        <Public v-show="gmShow" style="margin-bottom: 0"></Public>
        <Private v-show="smShow" style="margin-bottom: 0"></Private>
      </div>
    </div>
    <!-- 私募买入 -->
    <el-dialog class="dialog-single-four" :visible.sync="dialogVisable">
      <section class="instruction">
        <div class="dialog-single-four-adviser">
          <p class="p1">展恒顾问二维码</p>
          <img src="../../assets/images/private_buy.png" alt="" style="width:150px;height:150px;">
          <p class="p2">请前往展恒app进行操作，或扫码添加展恒基金专业顾问了解产品更多详情</p>
          <p class="p3">或拨打400-818-8000客服电话咨询</p>
        </div>
      </section>
    </el-dialog>
  </div>
</template>

<script>
import Hbb from '@/views/myAssets/hengBaobao/hbbAssetsMessage.vue';
import Public from '@/views/myAssets/publicFunds/publicAssetsMessage.vue';
import Private from '@/views/myAssets/privateFunds/privateAssetsMessage.vue';
// 滚动
import vueSeamlessScroll from 'vue-seamless-scroll'
import $ from 'jquery'
const Base64 = require("js-base64").Base64;
export default {
  name: "myAssets",
  components: {
    Hbb,
    Public,
    Private,
    vueSeamlessScroll
  },
  data () {
    return {
      //滚动
      listData: [1, 2, 3, 4, 5, 6],
      classOption: {
        limitMoveNum: 1,
        direction: 2,
      },
      cardCoupon: 0,
      integral: 0,
      memberDate: '无',
      // 扇形图表
      serierData: [
        { value: 0, name: '恒宝宝' },
        { value: 0, name: '公募基金' },
        { value: 0, name: '私募基金' },
      ],
      // 资产分布
      assetsTotal: '--',
      incomeLast: '--',
      incomeHold: '--',
      incomeTotal: '--',
      // 恒宝宝
      hbbTotalAssets: '--',
      hbbSyl: '--',
      hbbLastSY: '--',
      hbbAllSY: '--',
      // 公募基金
      publicTotalAssets: '--',
      publiclastSY: '--',
      publicholdSY: '--',
      publicallSY: '--',
      // 私募基金
      privateTotalAssets: '--',
      privateCount: '--',
      privateNewDate: '--',
      privateallSY: '--',
      count: 0,
      // 私募变量
      su: 0,
      qr: 0,   // 七日年化收益率
      pTotal: 0,  // qr + total  私募资产
      dayassets: 0,
      pzzc: 0,
      // 当前市值
      lineTotal: 0,
      unlineTotal: 0,
      fixTotal: 0,
      // 四模块显示
      hbbShow: true,
      gmShow: false,
      smShow: false,

      echartsLoading: true,
      noDataShow: false,
      overdueShow: false,
      hornShow: true,
      memberFlag: false,

      dialogVisable: false,

    }
  },
  created () {
    const member = window.sessionStorage.getItem('member')
    this.memberFlag = member == null ? this.memberFlag : (member == '1' ? true : false)
  },
  mounted () {
    this.getAxios()// 接口
    $('#fundModule>li').click(function () {
      $(this).addClass('active');
      $(this).siblings().removeClass('active');
    })
    this.getNotice()
    // 加本地存储
    const hbb = window.sessionStorage.getItem('hbb')
    const pub = window.sessionStorage.getItem('pub')
    const pri = window.sessionStorage.getItem('pri')
    const assets = [hbb, pub, pri]
    if (hbb != null && pub != null && pri != null) {
      this.assetsTotal = window.sessionStorage.getItem('assetsTotal') == null ? '--' : window.sessionStorage.getItem('assetsTotal')
      if (hbb == 0 && pub == 0 && pri == 0) {
        this.echartsLoading = false
        this.noDataShow = true
      } else {
        this.hbbTotalAssets = hbb
        this.publicTotalAssets = pub
        this.privateTotalAssets = pri
        for (var i = 0; i < this.serierData.length; i++) {
          this.serierData[i].value = assets[i]
        }
        this.echartsLoading = false
        this.noDataShow = false
        this.$commonEcharts.echartsPieOne('zz', this.serierData)
      }
    }


  },
  methods: {
    spread(type) {
      if(type == 'hbb') {
        this.hbbShow = !this.hbbShow
        this.gmShow = false
        this.smShow = false
      } else if(type == 'gm') {
        this.gmShow = !this.gmShow
        this.hbbShow = false
        this.smShow = false
      } else if(type == 'sm') {
        this.smShow = !this.smShow
        this.hbbShow = false
        this.gmShow = false
      }
    },
    
    exchangeClick () {
      this.$router.push({
        name: 'pointsExchange',
        params: {
          pathName: 'myAssets'
        }
      })
    },
    renewClick () {
      this.$router.push({
        name: 'memberBuy',
        params: {
          flag: this.memberFlag,
        }
      })
    },
    // 接口 
    async getAxios () {
      this.getCoupon()
      this.getSy()
      this.getMyAssets()
      await this.getPrivate()
      await this.getFloat()

      await this.getHbb()
      await this.getPublic()

      if (this.getDataState()) {
        if ($("#zz").length > 0) {
          this.$commonEcharts.echartsPieOne('zz', this.serierData)
        }
      }
      else {
        this.echartsLoading = false
        this.noDataShow = true
      }
    },
    getDataState () {
      if (this.serierData[0].value == 0 && this.serierData[1].value == 0 && this.serierData[2].value == 0)
        return false
      else
        return true
    },
    // 卡券
    getCoupon () {
      this.$http.post(this.$apiPath.queryCoupon, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        custno: this.$commonJs.getCookie('u_custno1'),
        status: '1',
        page: 1,
        pageInt: 1
      }).then(res => {
        // console.log(res);
        if (res.data.data) {
          this.cardCoupon = res.data.data.totalNum
        }
      }).catch(err => { })
      //
      this.$http.post(this.$apiPath.getUsIntegral, {
        identify: Base64.decode(this.$commonJs.getCookie('u_id'))
      }).then(res => {
        if (res.data.code !== '200') return
        // console.log(res);
        this.integral = parseInt(res.data.data.currpoint)

      }).catch(err => { })
      // 会员
      this.$http.post(this.$apiPath.checkContract, {
        identify: Base64.decode(this.$commonJs.getCookie('u_id'))
      }).then(res => {
        // console.log(res);
        if (res.data.code !== '200') return
        if (res.data.data[0]) {
          if (res.data.data[0].IsMember == "none") {
            this.memberDate = '无'
            this.memberFlag = false
          } else {
            this.memberDate = res.data.data[0].dend
            //判断过期
            let nowTime = this.$commonJs.timeFormat(new Date(), 'yyyy-mm-dd')
            let overdueResult = this.$commonJs.tab(nowTime, res.data.data[0].dend)
            if (overdueResult == '1') {
              this.overdueShow = true
              this.memberFlag = false
              this.$commonJs.setDomainCookie('dct_Member', '0')
              window.sessionStorage.setItem('member', '0')
            } else {
              this.overdueShow = false
              this.memberFlag = true
              this.$commonJs.setDomainCookie('dct_Member', '1')
              window.sessionStorage.setItem('member', '1')
            }
          }
        }
      }).catch(err => { })

    },
    // 恒宝宝接口
    async getHbb () {
      await this.$http.post(this.$apiPath.hbbasset, {
        sessionId: this.$commonJs.getCookie('sessionid')
      }).then(res => {
        // console.log(res);
        if (res.status !== 200) return
        if (res.data.code !== '200') {
          if (res.data.code == '10000003') {
            this.$router.push({ name: 'logout' })
          }
        }
        if (res.data.data) {
          const total = res.data.data[0][0]
          if (total.totalmktvalue < 0.00001) {
            this.hbbTotalAssets = parseFloat(total.totalmktvalue).toFixed(2)
            window.sessionStorage.setItem('hbb', parseFloat(total.totalmktvalue).toFixed(2))
            this.hbbLastSY = parseFloat(total.totalyestdayprofit).toFixed(2)
            this.hbbAllSY = parseFloat(total.totalfloatprofit).toFixed(2)
            return
          } else {
            this.hbbTotalAssets = parseFloat(total.totalmktvalue).toFixed(2)
            this.serierData[0].value = parseFloat(total.totalmktvalue).toFixed(2)
            window.sessionStorage.setItem('hbb', parseFloat(total.totalmktvalue).toFixed(2))
            this.hbbLastSY = parseFloat(total.totalyestdayprofit).toFixed(2)
            this.hbbAllSY = parseFloat(total.totalfloatprofit).toFixed(2)
          }
        }
      }).catch(err => { })
    },
    //恒宝宝收益率
    getSy () {
      this.$http.post(this.$apiPath.getPrivatelyFloat, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        fundcode: '162206',
        appnew: '1'
      }).then(res => {
        if (res.data.data) {
          const total = res.data.data[0]  // 出错
          this.hbbSyl = parseFloat(total.growthrate * 100).toFixed(2) + '%'
        }
      }).catch(err => { })
    },
    // 公募基金
    async getPublic () {
      await this.$http.post(this.$apiPath.fundasset, {
        sessionId: this.$commonJs.getCookie('sessionid')
      }).then(res => {
        // console.log(res);
        if (res.status !== 200) return
        if (res.data.code !== '200') return
        if (res.data.data) {
          const total = res.data.data
          if (total.totalmktvalue < 0.00001) {
            this.publicTotalAssets = parseFloat(total.totalmktvalue).toFixed(2)
            window.sessionStorage.setItem('pub', parseFloat(total.totalmktvalue).toFixed(2))
            this.publiclastSY = parseFloat(total.totalyestdayprofit).toFixed(2)
            this.publicholdSY = parseFloat(total.totalphaseprofit).toFixed(2)
            this.publicallSY = parseFloat(total.totalfloatprofit).toFixed(2)
            return
          } else {
            this.publicTotalAssets = parseFloat(total.totalmktvalue).toFixed(2)
            this.publiclastSY = parseFloat(total.totalyestdayprofit).toFixed(2)
            this.publicholdSY = parseFloat(total.totalphaseprofit).toFixed(2)
            this.publicallSY = parseFloat(total.totalfloatprofit).toFixed(2)
            this.serierData[1].value = parseFloat(total.totalmktvalue).toFixed(2)
            window.sessionStorage.setItem('pub', parseFloat(total.totalmktvalue).toFixed(2))
          }
        }
      }).catch(err => { })
    },
    // 私募基金
    async getPrivate () {  //资产privateTotalAssets 数量privateCount 日期privateNewDate 收益privateallSY
      await this.$http.post(this.$apiPath.getPrivatelyFloat, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        fundcode: '',
        appnew: '1'
      }).then(res => {
        if (res.status !== 200) return
        if (res.data.code !== '200') return
        // console.log(res);
        if (res.data.data == null) {
          // console.log('如果无数据，固定资产');
          this.getFix()
        }
        const privateList = res.data.data.privateList
        for (var i = 0; i < privateList.length; i++) {
          this.su++
          // 净购买金额+浮动利润
          this.qr += parseFloat(privateList[i].buymount) + parseFloat(privateList[i].floatprofit)
          // 浮动利润
          this.dayassets += parseFloat(privateList[i].floatprofit) == "" ? 0 : parseFloat(privateList[i].floatprofit);
          // 线上总市值
          this.lineTotal += (privateList[i].mktvalue - 0)

        }
        this.getFix()

      }).catch(err => { })



    },
    // 私募固定 
    getFix () {
      // 固定资产
      this.$http.post(this.$apiPath.selectFixPro, {
        identify: Base64.decode(this.$commonJs.getCookie('u_id'))//Base64.decode(this.$commonJs.getCookie('u_id'))   110105196311255474  310103197309072037
      }).then(res1 => {
        // console.log(res1);
        if (res1.status !== 200) return
        if (res1.data.code !== '200') return
        if (res1.data.data) {
          const total = res1.data.data
          for (var i = 0; i < total.length; i++) {
            this.count++;
            // 固定总市值
            this.fixTotal += Number(total[i].currnav) * Number(total[i].amountvol)
            // this.pTotal += Number(total[i].amountvol)  // 净值*份额，重算？？？？
          }

        }
      }).catch(err => { })

    },
    // 浮动
    async getFloat () { //资产privateTotalAssets 数量privateCount 日期 privateNewDate 收益privateallSY
      //浮动资产
      await this.$http.post(this.$apiPath.selectFloatPro, {
        identify: Base64.decode(this.$commonJs.getCookie('u_id'))
      }).then(res2 => {
        if (res2.status !== 200) return
        if (res2.data.code !== '200') return
        if (res2.data.data) {
          // console.log(res2);
          this.privateallSY = 0
          const total2 = res2.data.data
          // console.log(total2);
          if (total2) {
            for (var i = 0; i < total2.length; i++) {
              this.count++;
              this.pTotal += Number(total2[i].currnav) * Number(total2[i].amountvol);
              this.privateallSY += Number(total2[i].currnav) * Number(total2[i].amountvol) - Number(total2[i].costamount);
              // 线下总市值
              this.unlineTotal += (total2[i].curramount - 0)
            }
            this.privateCount = parseFloat(this.count) + parseFloat(this.su);
            if (this.pTotal == 0 && this.qr == 0) {
              this.count = 0
            }
            if (total2[0]) {
              // 最新净值日期
              this.privateNewDate = total2[0].navdate.substr(0, 10)
            }
            // 收益
            this.privateallSY = (parseFloat(this.privateallSY) + this.dayassets).toFixed(2)
            // 私募总资产                  线上               线下                    固定
            this.privateTotalAssets = (this.lineTotal + this.unlineTotal + parseFloat(this.fixTotal)).toFixed(2)
            if (this.privateTotalAssets < 0.00001) {
              window.sessionStorage.setItem('pri', parseFloat(this.privateTotalAssets).toFixed(2))
              return
            } else {
              this.serierData[2].value = parseFloat(this.privateTotalAssets).toFixed(2)
              window.sessionStorage.setItem('pri', parseFloat(this.privateTotalAssets).toFixed(2))
            }
          }
        } else {
          if (this.pTotal == 0 & this.qr == 0) {
            this.count = 0;
          }
          this.privateCount = parseFloat(this.count) + parseFloat(this.su);
          this.privateNewDate = '暂无'
          this.privateallSY = (parseFloat(this.privateallSY) + this.dayassets).toFixed(2)
          // 私募总资产
          this.privateTotalAssets = (this.lineTotal + this.unlineTotal + parseFloat(this.fixTotal)).toFixed(2)
        }
      }).catch(err => { })

    },
    // 总资产
    getMyAssets () {
      this.$http.post(this.$apiPath.allasset, {
        sessionId: this.$commonJs.getCookie('sessionid')
      }).then(res => {
        // console.log(res);
        if(res.data.code == 200) {
          const total = res.data.data
          if (parseFloat(this.privateTotalAssets) > 0) {// 总资产，持有首页
            this.assetsTotal = ((parseFloat(total.totalmktvalue).toFixed(2) - 0) + (this.privateTotalAssets - 0)).toFixed(2)
            this.incomeHold = ((parseFloat(total.totalphaseprofit).toFixed(2) - 0) + (this.privateallSY - 0)).toFixed(2)
          } else {
            this.assetsTotal = parseFloat(total.totalmktvalue).toFixed(2)
            this.incomeHold = parseFloat(total.totalphaseprofit).toFixed(2)
          }
          window.sessionStorage.setItem('assetsTotal', this.assetsTotal)
          this.incomeLast = parseFloat(total.totalyestdayprofit).toFixed(2)
          this.incomeTotal = parseFloat(total.totalfloatprofit).toFixed(2)
        }
      }).catch(err => { })
    },
    //公告
    getNotice () {
      this.$http.post(this.$apiPath.getAnnouncementPC, {}).then(res => {
        // console.log(res);
        if(res.data.code == 200) {
          let gongGao = '';
          if (res.data.data && res.data.data.length > 0) {
            res.data.data.forEach((val, i) => {
              gongGao += (i + 1) + ' .' + val.summary + ' '
            })
            $('.li-item').html(gongGao)
          } else {
            this.hornShow = false
          }
        } else {
          this.hornShow = false
        }
      }).catch(err => { })
    },
  }
}
</script>

<style lang="less" scoped>
.myassets {
  padding-bottom: 20px;
}
.assets {
  position: relative;
  height: 350px;
  border: 1px solid #c8c8c8;
  border-top: none;
  .assets_con {
    width: 100%;
    height: 265px;
    padding: 18px 0;
    border-top: 1px solid @colorC8;
    .distribution {
      position: relative;
      width: 65%;
      height: 100%;
      &_words {
        position: relative;
        margin-left: 28px;
        color: #2a2a2a;
        font-size: 18px;
        font-weight: bold;
        z-index: 9999999;
      }
      &_detail {
        box-sizing: border-box;
        width: 37%;
        height: 100%;
        position: absolute;
        top: 6px;
        right: 40px;
        li {
          font-size: 20px;
          width: 100%;
          margin: 28px 0;
          text-align: left;
          color: #333;
          span {
            font-size: 20px;
            color: #2a2a2a;
            font-weight: bold;
          }
        }
      }
    }
    .dottedLine {
      width: 5px;
      height: 100%;
      box-sizing: border-box;
      border-left: 1px dashed #bfbfbf;
      border-right: 1px dashed #bfbfbf;
    }
    .coupon {
      width: calc(35% - 5px);
      height: 100%;
      box-sizing: border-box;
      padding: 20px 50px;
      // background: blue;
      .couponCard {
        width: 100%;
        height: 50%;
        // background: pink;
        .coupon1 {
          color: #246ead;
          font-size: 18px;
          font-weight: bold;
          cursor: pointer;
        }
        .coupon2 {
          color: #333;
          margin: 12px 0;
          li {
            display: inline-block;
          }
          li:nth-child(2) {
            position: absolute;
            left: 126px;
          }
        }
      }
    }
  }
  .assets_foot {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 45px;
    line-height: 45px;
    background: #d3e2ef;
    // padding-left: 50px;
    .hornImg {
      position: absolute;
      top: 50%;
      left: 27px;
      transform: translateY(-50%);
    }
    // 公告
    .hornTit {
      position: absolute;
      width: 1000px;
      left: 60px;
    }
    .hornWords {
      position: absolute;
      width: 1080px;
      left: 100px;
      top: 0px;
      overflow: hidden;
      span {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
      }
    }
  }
}
// 模块
.fundModule {
  height: 333px;
  border: 1px solid #c8c8c8;
  margin-top: 10px;

  .mod {
    position: relative;
    box-sizing: border-box;
    float: left;
    width: 33.3%;
    height: 100%;
    padding: 0 20px;
    border-right: 1px solid #c8c8c8;
    // cursor: pointer;
    .fundTol {
      margin-left: 15px;
      padding-bottom: 18px;
      color: #747474;
      font-size: 14px;
      border-bottom: 1px dashed #c8c8c8;
      span {
        margin-left: 20px;
        color: #000;
        font-size: 26px;
        font-weight: bold;
      }
    }
    .profitBox {
      margin-left: 15px;
      margin-top: 18px;
      color: #747474;
      font-size: 14px;
      li {
        margin-bottom: 20px;
        color: #747474;
        span {
          font-weight: bold;
        }
      }
    }
    .fundOperation {
      margin-left: 12px;
    }
    .open {
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      color: #246ead;
      cursor: pointer;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }
  }
  .mod:hover,
  .active {
    // border: 3px solid #91b6d6;
    box-shadow: #91b6d6 0px 0px 9px;
    // background: #000;
  }
  li:last-child {
    border-right: none;
  }
}

.colorBlue {
  color: #246ead;
  font-weight: bold;
}

.noData {
  width: 194px;
  height: 194px;
  position: absolute;
  top: 35px;
  left: 139px;
}
.overdue {
  position: absolute;
  top: 33px;
  right: -20px;
}

//公告
.warp {
  // width: 8000px; 10000px; 15000px;
  width: 10000px;
  height: 120px;
  margin: 0 auto;
  overflow: hidden;
  ul {
    list-style: none;
    padding: 0;
    margin: 0 auto;
    &.ul-item {
      display: flex;
      .li-item {
        //   width: 3500px; 4000px; 6000px;
        width: 4000px;
        height: 45px;
        margin-right: 10px;
        line-height: 45px;
        text-align: center;
      }
    }
  }
}
</style>

